import BaseApiModel from "scripts/models/baseApiModel";

class DisqusModel extends BaseApiModel {
  url() {
    return `${this.apiUrlRoot}/comments/${this.id}/disqus-context`;
  }
}

export default DisqusModel;
